import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default ({
  state: {
    loadedCalendarEvents: []
  },
  mutations: {
    createCalendarEvent (state, payload) {
      state.loadedCalendarEvents.push(payload)
    },
    setLoadedCalendarEvents (state, payload) {
      state.loadedCalendarEvents = payload
    },
    updateCalendarEvent (state, payload) {
      const event = state.loadedCalendarEvents.find(event => {
        return event.id === payload.id
      })
      if (payload.name) {
        event.name = payload.name
      }
      if (payload.location) {
        event.location = payload.location
      }
      if (payload.date) {
        event.date = payload.date
      }
      if (payload.startdate) {
        event.startdate = payload.startdate
      }
      if (payload.enddate) {
        event.enddate = payload.enddate
      }
      if (payload.starttime) {
        event.starttime = payload.starttime
      }
      if (payload.endtime) {
        event.endtime = payload.endtime
      }
      if (payload.participants) {
        event.participants = payload.participants
      }
      if (payload.notes) {
        event.notes = payload.notes
      }
    },
    deleteEvent (state, payload) {
      for (var i = 0; i < state.loadedCalendarEvents.length; i++) {
        if (state.loadedCalendarEvents[i].id === payload) {
          state.loadedCalendarEvents.splice(i, 1)
        }
      }
    }
  },
  actions: {
    createCalendarEvent ({ commit }, payload) {
      const event = {
        name: payload.name,
        location: payload.location,
        participants: payload.participants,
        start: payload.timestamp1,
        end: payload.timestamp2,
        startdate: payload.startdate,
        enddate: payload.enddate,
        starttime: payload.starttime,
        endtime: payload.endtime,
        notes: payload.notes,
        color: payload.color,
        date: payload.date,
        timed: '!allDay'
      }
      firebase.database().ref('calendar events').push(event)
        .then((data) => {
          console.log(data)
        })
      commit('createCalendarEvent', event)
    },
    loadCalendarEvents ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('calendar events').once('value')
        .then((data) => {
          const events = []
          const obj = data.val()
          for (const key in obj) {
            events.push({
              id: key,
              name: obj[key].name,
              location: obj[key].location,
              participants: obj[key].participants,
              start: obj[key].start,
              end: obj[key].end,
              startdate: obj[key].startdate,
              enddate: obj[key].enddate,
              starttime: obj[key].starttime,
              endtime: obj[key].endtime,
              notes: obj[key].notes,
              color: obj[key].color,
              date: obj[key].date,
              timed: '!allDay'
            })
          }
          commit('setLoading', false)
          commit('setLoadedCalendarEvents', events)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    updateCalendarEvent ({ commit }, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.name) {
        updateObj.name = payload.name
      }
      if (payload.location) {
        updateObj.location = payload.location
      }
      if (payload.participants) {
        updateObj.participants = payload.participants
      }
      if (payload.start) {
        updateObj.start = payload.start
      }
      if (payload.end) {
        updateObj.end = payload.end
      }
      if (payload.startdate) {
        updateObj.startdate = payload.startdate
      }
      if (payload.enddate) {
        updateObj.enddate = payload.enddate
      }
      if (payload.starttime) {
        updateObj.starttime = payload.starttime
      }
      if (payload.endtime) {
        updateObj.endtime = payload.endtime
      }
      if (payload.notes) {
        updateObj.notes = payload.notes
      }
      if (payload.color) {
        updateObj.color = payload.color
      }
      if (payload.date) {
        updateObj.date = payload.date
      }
      if (payload.enddate) {
        updateObj.enddate = payload.enddate
      }
      firebase.database().ref('calendar events').child(payload.id).update(updateObj)
        .then(() => {
          commit('setLoading', false)
          commit('updateCalendarEvent', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    deleteEvent ({ commit }, payload) {
      firebase.database().ref('members').child(payload).remove()
      commit('deleteEvent', payload)
    }
  },
  getters: {
    loadedCalendarEvents (state) {
      return state.loadedCalendarEvents.sort((eventA, eventB) => {
        return eventA.id > eventB.id
      })
    },
    loadedCalendarEvent (state) {
      return (eventId) => {
        return state.loadedCalendarEvents.find((event) => {
          return event.id === eventId
        })
      }
    },
    loadTodayEvent (state) {
      var eventlist = []
      for (var i = 0; i < state.loadedCalendarEvents.length; i++) {
        // console.log(state.loadedCalendarEvents[i].startdate)
        if (state.loadedCalendarEvents.startdate === '2020-12-03') {
          eventlist.push(state.loadedCalendarEvents[i])
        }
      }
      return eventlist
    }
  }
})
